import {QueryCommand} from "xmgoing-server";

export function useMenuSearchHooks(){

  const searchMenuList=ref('');
  const searchMenuKey = ref('');

  //获取收藏到菜单集合
  const searchMenus = (backFun) => {
    const queryCommand = new QueryCommand({
      method: "POST",
      url: '/api/pe-portal/resource/queryMenu',
      showTip: false,
    });
    queryCommand.executeQueryPromise({params: {name:unref(searchMenuKey)}}).then((des) => {
      backFun && backFun(des);
    })
  }


  /**
   * 查询菜单
   */
  const searchMenuFun=function (){
    if((unref(searchMenuKey)+'').length>0){
      searchMenus((res:any)=>{
        searchMenuList.value=res;
      });
    }else{
      searchMenuList.value=[];
    }

  }

  const queryTimer:any=ref(null);
  /**
   * 输入查询操作
   */
  const changInput=function (){
    searchMenuList.value=[];
    if(queryTimer.value){
      clearTimeout(queryTimer.value);
    }
    queryTimer.value=setTimeout(()=>{
      searchMenuFun()
    },200)
  }

  return {
    searchMenuList,
    changInput,
    searchMenuKey,
    searchMenuFun
  }
}
